export default {
    API_BASE_URL: 'https://admin.binhnganshop.com/api',
    INIT_URL: '/app/pos-orders/list'
}